import { useStoreMap, useUnit } from 'effector-react';
import { $menuState } from '@nx-frontend/shared/store/feature-menu-tree';
import { $page } from '@nx-frontend/shared/store/portal-page';
import { MenuItem, PortalMenuTypes } from '@nx-frontend/shared/types/menu';

interface GetSubmenuItemsProps {
  menuItemId?: string;
}

export const useGetSubmenuItems = ({ menuItemId }: GetSubmenuItemsProps = {}): MenuItem[] => {
  const [page] = useUnit([$page]);

  return useStoreMap({
    keys: [PortalMenuTypes, page, menuItemId],
    defaultValue: [],
    store: $menuState,
    fn: (state, [types, page, menuItemId]) => {
      for (const type of types) {
        const { entities } = state[type];
        const currentItem = Object.values(entities).find((item) =>
          menuItemId != null ? item.id === menuItemId : item.url === page.path || item.originalUrl === page.path
        );
        if (currentItem?.order?.length) {
          return currentItem.order.map((id) => entities[id]);
        }
      }
      return [];
    },
  });
};
